export default {"trigger":"bRTy3","menuItem":"J16e0","manageSubsDialog":"lL-3R","buttonWrapper":"gaUUn","closeDialog":"DbgrK"};